export function maxLengthValidator($el) {
  if (!$el.val()) {
    return true;
  }
  const maxLength = +$el.attr("maxlength") || Infinity;
  const valueLength = $el.val().length;
  return valueLength <= maxLength;
}
Foundation.Abide.defaults.validators["max_length"] = maxLengthValidator;
